import React, { FC, InputHTMLAttributes } from "react";
import clearInputIconImage from "./svg/clear-input-icon.svg";

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> {
  value: string;
  onChange: (value: string) => void;
  showClearButton?: boolean;
  className?: string;
  wrapperClassName?: string;
}

const Input: FC<InputProps> = ({
  value,
  onChange,
  className,
  wrapperClassName,
  showClearButton,
  ...props
}) => {
  return (
    <div
      className={`w-fit relative ${wrapperClassName ? wrapperClassName : ""}`}
    >
      <input
        className={`rounded-lg border border-themed-border bg-themed-input px-3 py-1.5 font-manrope text-[13px] leading-[20px] text-themed-text outline-none transition-colors placeholder:text-themed-textSecondary placeholder:opacity-70 focus:border-themed-accent ${
          showClearButton && value !== "" ? "!pr-[30px]" : ""
        } ${className ? className : ""}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...props}
      />
      {showClearButton && value !== "" && (
        <button
          className="absolute top-1/2 -translate-y-1/2 right-[12px]"
          onClick={() => onChange("")}
        >
          <img src={clearInputIconImage} />
        </button>
      )}
    </div>
  );
};

export default Input;
